import React, { memo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTheme, Badge } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import PhoneIcon from "@mui/icons-material/Phone";
import { selectUserPresence } from "../../../state/presence/presenceSlice";

const PresenceAvatar = memo(
  ({
    contactNumber,
    size = size,
    CustomIcon = AccountCircleRoundedIcon,
    showPresence = true,
  }) => {
    const theme = useTheme();
    const presence = useSelector((state) =>
      selectUserPresence(state, contactNumber)
    );

    // If not a presence, return default icon
    if (!presence) {
      return (
        <AccountCircleRoundedIcon
          sx={{
            fontSize: size,
            flexShrink: 0,
          }}
        />
      );
    }

    const getPresenceColor = () => {
      switch (presence) {
        case "open":
          return theme.palette.customColors.phoneStatusActive;
        case "inactive":
          return theme.palette.grey[500];
        case "closed":
        case "busy":
          return theme.palette.customColors.phoneStatusInactive;
        default:
          return theme.palette.customColors.phoneStatusInactive;
      }
    };

    // const BadgeIcon = () => (
    //     <div
    //         style={{
    //             background: getPresenceColor(),
    //             borderRadius: '50%',
    //             padding: size * 0.1,
    //             border: `2px solid ${theme.palette.background.paper}`,
    //             display: 'flex',
    //             alignItems: 'center',
    //             justifyContent: 'center'
    //         }}
    //     >
    //         <PhoneIcon
    //             sx={{
    //                 fontSize: size * 0.3,
    //                 color: theme.palette.common.white
    //             }}
    //         />
    //     </div>
    // );

    const BadgeIcon = () => (
      <div
        style={{
          background: getPresenceColor(),
          width: size * 0.33,
          height: size * 0.33,
          borderRadius: "50%",

          border: `2px solid ${theme.palette.background.paper}`,
        }}
      />
    );

    return (
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={showPresence ? <BadgeIcon /> : null}
        sx={{
          "& .MuiBadge-badge": {
            transform: "translate(40%, 40%)",
          },
        }}
      >
        <CustomIcon
          sx={{
            fontSize: size,
            flexShrink: 0,
          }}
        />
      </Badge>
    );
  }
);

PresenceAvatar.propTypes = {
  contactNumber: PropTypes.string.isRequired,
  size: PropTypes.number,
  CustomIcon: PropTypes.elementType,
  showPresence: PropTypes.bool,
};

export default PresenceAvatar;
